module.exports = __webpack_public_path__ + "static/media/projify.f2e07273.png";